
import { relatorios } from "./utils/relatorio";

export const routes = [

  {
    path: '/dashboard-administrativo2',
    component: () => import(/* webpackChunkName: "administrative-dashboard" */ './newAdmin/resumo'),
    name: 'administrative.dashboard',
    redirect: to => { return 'dashboard-administrativo2/graficos' },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard-administrativo2/graficos',
    component: () => import(/* webpackChunkName: "administrative-dashboard" */ './newAdmin/resumo'),
    name: 'administrative.dashboard',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dashboard-administrativo2/relatorio/:relatorioRoute',
    component: () => import(/* webpackChunkName: "administrative-dashboard" */ './newAdmin/resumo'),
    name: 'administrative.dashboard',
    meta: {
      requiresAuth: true,
      verifyVisibleRelatorio: true
    }
  }
]
